import { anchorLink } from "../include/module";
import { mainNavCurrent } from "../include/module";
import { modalPopup } from "../include/module";
anchorLink();
mainNavCurrent();
modalPopup();



// WEBPACK FOOTER //
// ./src/assets/js/entry/script.js